export const calculateAllowEditing = bcColumn => {
	if (bcColumn.editType === 'actionButton') {
		return false;
	}

	return bcColumn.editingEnabled && !bcColumn.autoIncrement;
};
